<script setup lang="ts">
  import { vMaska } from 'maska/vue';
  import { MASK_PRESETS } from '@/shared/lib/mask';
  import type { CompiledFieldNode, FieldValue } from '@record-fill';

  const props = defineProps<{ node: CompiledFieldNode; disabled: boolean; readOnly?: boolean; inputClass?: string }>();
  const emit = defineEmits<{ (e: 'update', value: FieldValue): void }>();

  const control = props.node.control.kind === 'text' ? props.node.control : null;
  const maskConfig = { mask: MASK_PRESETS.register_number, eager: false };

  function onInput(event: Event): void {
    emit('update', (event.target as HTMLInputElement).value.replace(/\D/g, ''));
  }
</script>

<template>
  <input
    v-maska="maskConfig"
    type="text"
    :class="[
      inputClass,
      { 'cursor-default': readOnly },
      'w-full min-w-0 text-[11px] leading-4 [font-family:var(--font-base)] placeholder:text-[10px] placeholder:opacity-60 disabled:cursor-not-allowed disabled:bg-[var(--color-gray-09)] disabled:opacity-60',
    ]"
    :value="typeof node.value === 'string' ? node.value : ''"
    :placeholder="control?.placeholder"
    :aria-label="node.label"
    :disabled="disabled"
    :readonly="readOnly"
    :tabindex="readOnly ? -1 : undefined"
    :data-field-id="node.id"
    @input="onInput"
  >
</template>
